module.exports = __webpack_public_path__ + "static/media/2.536ed467.png";